"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearFloats = clearFloats;
// =============================================================================
// FLOAT (Tools)
// =============================================================================
// 1. The use of `table` rather than `block` is only necessary if using
//  ':before' to contain the top-margins of child elements.
// -----------------------------------------------------------------------------
function clearFloats() {
  return "\n    &:before,\n    &:after {\n      content: '';\n      display: table; // 1\n    }\n\n    &:after {\n      clear: both;\n    }\n  ";
}
//# sourceMappingURL=float.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/toolkit/tools/float.js